module.exports = __webpack_public_path__ + "static/media/child-logo.020acb6f.svg";